import {
	CaseInformationType,
	ContactInformationType,
	JsonData,
	AddressInformationType,
	DeterminationType,
	EmploymentIncomeType,
	AssetsType,
	DebtsType,
	ExpensesType,
	ProgressSteps,
	SignatureType,
} from '../types';
import dataJson from '../../data/data.json';
import progressStepsJson from '../../data/progress.json';

export interface FinancialStatusProviderProps {
	children: React.ReactNode;
}

export type PlaceholderFunctionProps = {
	step: keyof JsonData;
	value: string;
};

export interface FinancialStatusContextProps {
	language: 'en' | 'es';
	setLanguage: (language: 'en' | 'es') => void;
	currentStep: number;
	updateCurrentStep: (step: number) => void;
	getPlaceholder: ({ step, value }: PlaceholderFunctionProps) => string;
	validatedSteps: string[];
	jsonData: JsonData;
	progressSteps: ProgressSteps;
	updateCaseInformation: (data: CaseInformationType) => void;
	updateContactInformation: (data: ContactInformationType) => void;
	updateAddressInformation: (data: AddressInformationType) => void;
	updateDetermination: (data: DeterminationType) => void;
	updateEmploymentIncomeData: (data: EmploymentIncomeType) => void;
	updateAssets: (data: AssetsType) => void;
	updateDebts: (data: DebtsType) => void;
	updateExpenses: (data: ExpensesType) => void;
	updateSignature: (data: SignatureType) => void;
	submitForm: (data: SignatureType) => Promise<void>;
	isSubmitting: boolean;
	hasSubmissionError: boolean;
	pdfHref: string | undefined;
}
const data: JsonData = dataJson as JsonData;
const progressSteps: ProgressSteps = progressStepsJson as ProgressSteps;

export const defaultContextProps: FinancialStatusContextProps = {
	language: 'en',
	setLanguage: () => {},
	currentStep: 0,
	updateCurrentStep: () => {},
	getPlaceholder: () => '',
	validatedSteps: [],
	jsonData: data,
	progressSteps,
	updateCaseInformation: () => {},
	updateContactInformation: () => {},
	updateAddressInformation: () => {},
	updateDetermination: () => {},
	updateEmploymentIncomeData: () => {},
	updateAssets: () => {},
	updateDebts: () => {},
	updateExpenses: () => {},
	updateSignature: () => {},
	submitForm: async () => {},
	isSubmitting: false,
	hasSubmissionError: false,
	pdfHref: undefined,
};
